import React, { useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { GameSection, GameStructure, useSoundWatcher } from '@pascal/pascal-core';

import { liveBetsDataStore } from '../store/liveBetsDataStore';

import { HeaderWr } from './header';
import { WebGameMain } from '../game';

export const WebGame = observer(() => {
  // const { roomName } = useLobbyStore();
  useSoundWatcher();

  useEffect(() => {
    return () => {
      liveBetsDataStore.resetLiveBetsData([]);
    };
  }, []);

  return (
    <GameStructure>
      <HeaderWr />
      <GameSection haveNotification translationValues={{}}>
        <WebGameMain />
      </GameSection>
    </GameStructure>
  );
});
